import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';

export function NavPublicPricing() {
  return (
    <Hyperlink
      className="nav__item button clear secondary nav__button hide_on--mobile"
      href="/tarifs"
      source="nav"
      title="Tarifs"
    >
      <FormattedMessage id="navigation/pricing/NavPublicPricing.tsx/1" />
    </Hyperlink>
  );
}
